import React from "react";
import { useLocation } from "react-router-dom";
import TicketDetailCard from "./components/TicketDetailCard";

const ViewTicketDetail = () => {
    const { state } = useLocation();

    const ticket = state?.ticket; 

    return (
        <div className="max-w-6xl mx-auto">
            {ticket ? (
                <TicketDetailCard ticket={ticket} mode="view" />
            ) : (
                <p className="text-center text-red-500 mt-6">Ticket not found.</p>
            )}
        </div>
    );
};

export default ViewTicketDetail;
